import SectionHeader from "@able/react/dist/SectionHeader";
import { useTableHeaderContext } from "./TableContext";

const TableTitle = () => {
    const { title, subtitle, titleElement } = useTableHeaderContext();

    if (!title) return null;

    return (
        <SectionHeader variantLevel={"Level1"} headingElement={titleElement} title={title} subtitle={subtitle} />
    );
}

export default TableTitle;